import { getAccessToken } from "../utils/storage";

import Axios from "../utils/http-request";
import { NewsfeedProps } from "../interface/newsfeed";

interface MetaData {
  current_page: number;
  last_page: number;
}

interface APIResponse<T> {
  data: T[];
  meta: MetaData;
  current_page: number;
  last_page: number;
  total: number;
}

interface PaginationParams {
  page: number;
  page_size: number;
  search: string;
}

export const apiGetNewsfeed = async (
  pagination: PaginationParams
): Promise<{ data: APIResponse<NewsfeedProps> }> => {
  const { accessToken, tokenType } = await getAccessToken();
  const uri = `/feeds?search=${pagination.search}&page=${pagination.page}&page_size=${pagination.page_size}&sort_order=asc`;
  const cfg = {
    headers: {
      Authorization: `${tokenType} ${accessToken}`,
    },
  };

  try {
    const result = await Axios.get<APIResponse<NewsfeedProps>>(uri, cfg);
    return { data: result.data }; // Successful response
  } catch (e: any) {
    console.error(e);
    // Return a consistent error shape
    return {
      data: {
        data: [],
        meta: { current_page: pagination.page, last_page: pagination.page },
        current_page: 1,
        total: 1,
        last_page: 1,
      },
    };
  }
};
